<script>
import request from "@/services/request";
import { mapActions } from "vuex";
import ModalProgramGroupUserForm from "@/components/programs/groups_user/ModalProgramGroupUserForm.vue";
import ModalMoveUserGroup from "@/components/programs/groups_user/ModalMoueUserGroup.vue";

export default {
    name: "ModalProgramGroupUsersList",
    components: {
        ModalProgramGroupUserForm,
        ModalMoveUserGroup
    },
    data() {
        return {
            loading: true,
            groups: [],
            program_id: "",
            expanded: null,
            assigned_users_program: [],
        };
    },

    methods: {
        closeModal() {
            this.groups = [];
            this.program_id = "";
            this.$modal.hide("modalProgramGroupUsersList");
        },

        toggleAccordion(id) {
            this.expanded = this.expanded === id ? null : id;
        },

        async loadGroups() {
            this.loading = true;

            let _endpoint = `/programs/${this.program_id}/groups-users`;

            try {
                let { data } = await request.get(_endpoint);

                this.groups = data;

                let allUsers = [];

                this.groups.forEach(g => {
                    g.users.forEach(u => {
                        allUsers.push(u.id);
                    });
                });

                this.assigned_users_program = [...new Set(allUsers)];

            } catch (error) {
                console.log(error);
            }

            this.loading = false;
        },

        openAddUserModal(group) {
            const allUsers = this.groups.map(g => g.program_group_users.map(u => `${u.user_id}|${u.company_id}`));

            Event.$emit("event-open-program-group-users", {
                group_id: group.id,
                assigned_users_program: allUsers,
                companies: group.companies.map(c => c.id)
            });
        },

        async deleteRelation(pivot_id) {

            this.$swal({
                title: "¿Eliminar usuario del grupo?",
                text: "Esta acción no se puede deshacer",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: "Sí, eliminar",
                cancelButtonText: "Cancelar"
            }).then(async (result) => {
                if (result.isConfirmed) {
                    try {
                        let { data } = await request.destroy(`/program_group_users/${pivot_id}`);

                        this.successNotification(data.message);

                        this.loadGroups(); // recargar lista
                    } catch (error) {
                        this.errorNotification(error);
                    }
                }
            });
        },

        openMoveUserModal(user, currentGroup) {
            Event.$emit("event-open-move-program-group-user", {
                program_id: this.program_id,
                user: user,
                current_group: currentGroup,
                groups: this.groups.map(g => ({
                    id: g.id,
                    name: g.name
                }))
            });
        },

        ...mapActions({
            errorNotification: "alert/error",
            successNotification: "alert/success",
        }),
    },

    created() {
        Event.$on("event-open-program-groups-users-list", async (data) => {
            this.program_id = data.program_id;

            await this.loadGroups();

            this.$modal.show("modalProgramGroupUsersList");
        });

        Event.$on("event-reload-program-relations", async () => {
            this.loadGroups();
        });
    }
}
</script>

<template>
    <modal name="modalProgramGroupUsersList" :width="'70%'" :height="'auto'" :click-to-close="false">

        <button type="button" class="btn btn-danger btn-sm btn-closed" @click="closeModal">
            <i class="fa-solid fa-xmark"></i>
        </button>

        <div class="modal-header">
            <h4 class="modal-title">Usuarios por Grupo</h4>
        </div>

        <div class="modal-body">

            <div v-if="loading" class="text-center">
                <i class="fa-solid fa-circle-notch fa-spin fa-3x mb-2"></i>
                <h5>Cargando grupos...</h5>
            </div>

            <div v-else>

                <div v-for="group in groups" :key="group.id" class="mb-3">

                    <!-- ENCABEZADO DEL ACORDEÓN -->
                    <div class="p-2 bg-primary text-white d-flex justify-content-between align-items-center"
                        @click="toggleAccordion(group.id)" style="cursor: pointer; border-radius: 5px;">
                        <strong>{{ group.name }}</strong>

                        <i :class="expanded === group.id ? 'fa-solid fa-angle-up' : 'fa-solid fa-angle-down'"></i>
                    </div>

                    <!-- CONTENIDO -->
                    <div v-show="expanded === group.id" class="border p-3">

                        <button class="btn btn-sm btn-outline-success mb-3 float-right"
                            @click="openAddUserModal(group)">
                            <i class="fa fa-plus"></i> Agregar Usuario
                        </button>

                        <table class="table table-bordered text-center text-sm">
                            <thead>
                                <tr>
                                    <th>ID</th>
                                    <th>Usuario</th>
                                    <th>Compañía</th>
                                    <th>Monto / Aportaciones</th>
                                    <th>Porcentaje</th>
                                    <th>Opciones</th>
                                </tr>
                            </thead>

                            <tbody v-if="group.program_group_users.length > 0">
                                <tr v-for="u in group.program_group_users" :key="u.id">
                                    <td>{{ u.id }}</td>
                                    <td>{{ u.user?.name }} {{ u.user?.last_name }}</td>
                                    <td>{{ u.company?.name }}</td>
                                    <td>
                                        <span v-if="u.program_type_id == 1">
                                        {{ u.amount | toCurrency }}
                                        <br>-<br>
                                        </span>
                                        {{ u.total_amount | toCurrency }}
                                    </td>
                                    <td>{{ u.percentage }}</td>
                                    <td>
                                        <button class="btn btn-sm btn-outline-danger m-1" v-if="u.total_amount == 0"
                                            @click="deleteRelation(u.pivot.id)">
                                            Quitar
                                        </button>
                                        <button class="btn btn-sm btn-outline-primary m-1" @click="openMoveUserModal(u, group)">
                                            Mover de grupo
                                        </button>
                                    </td>
                                </tr>
                            </tbody>

                            <tbody v-else>
                                <tr>
                                    <td colspan="3">Sin usuarios en este grupo.</td>
                                </tr>
                            </tbody>
                        </table>

                    </div>
                </div>

            </div>
        </div>
        <ModalProgramGroupUserForm />

        <ModalMoveUserGroup />
    </modal>
</template>

<style scoped>
.bg-primary {
    background-color: #214d83 !important;
}
</style>
